import React from 'react'
import { withTranslation } from 'react-i18next'

import letter from '../svg/letter.svg'
import { Helmet } from 'react-helmet'

const Investors = ({ t }) => {
    return (
        <div className="container-investors-page">
            <Helmet>
                <title>{t('_pages._investors.title')} | Interacty</title>
            </Helmet>

            <h1>{t('_pages._investors.title')}</h1>
            <img src={letter} alt="" />
            <article>{t('_pages._investors.article')}</article>
            <a href="mailto:special@interacty.com" className="email">
                special@interacty.com
            </a>
        </div>
    )
}

export default withTranslation('translations')(Investors)
